/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  Button,
  FormControl, FormControlLabel,
  FormHelperText,
  InputAdornment,
  InputLabel, Switch,
  TextField
} from '@material-ui/core'
import { useStyles } from './Styles'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'

const TopUps = ({ topups, ServiceForm, topUpsCompleted, setTopUpsCompleted }) => {
  const classes = useStyles()
  const intl = useIntl()
  const [topUps, setTopUps] = React.useState(topups?.map(topup => ({
    ...topup,
    is_active: !!parseInt(topup.is_active)
  })) || [])
  const [topUpsValidArr, setTopUpsValidArr] = React.useState([])

  const [topUpsDuplicated, setTopUpsDuplicated] = React.useState([])

  const checkAllDataCompleted = (currentData) => {
    let valid = true
    let data = !!currentData ? currentData : topUps
    let duplicated = []
    if (!!data.length) {
      data.forEach((item) => {
        if ((!item.price && item.price !== 0) || (!item.quota && item.quota !== 0) || !item.title) {
          valid = false
        }
      })
      let valueArr = data.map(item => [item.quota, item.price].join('-'))
      duplicated = valueArr.map((item, idx) => valueArr.indexOf(item) !== idx)
      setTopUpsDuplicated(duplicated)
    }
    setTopUpsCompleted(valid)

    if (!!valid && !duplicated?.filter(dup => !!dup).length) {
      ServiceForm.setFieldValue('topups', data)
    }

    return valid
  }

  const handleTopUpRecordChange = (e, valueIndex, fieldName) => {
    if (!!e) {
      e.preventDefault()
      e.stopPropagation()
    }
    let validations = [...topUpsValidArr]
    if (fieldName !== 'is_active') {
      if (!e?.target?.value && e?.target?.value !== 0) {
        if (!!validations[valueIndex] && !!Object.keys(validations[valueIndex]).length) {
          validations[valueIndex][fieldName] = true
        } else {
          validations[valueIndex] = {}
          validations[valueIndex][fieldName] = true
        }
      } else {
        if (!!validations.length && !!validations[valueIndex] && !!Object.keys(validations[valueIndex]).length && !!validations[valueIndex][fieldName]) {
          delete (validations[valueIndex][fieldName])
          if (!Object.keys(validations[valueIndex]).length) {
            validations.splice(valueIndex, 1)
            // delete (validations[valueIndex])
          }
        }
      }
    }
    let exactDataValue = [...topUps]
    exactDataValue[valueIndex][fieldName] = (fieldName === 'is_active') ? !exactDataValue[valueIndex][fieldName] : e.target.value?.toString()
    checkAllDataCompleted(exactDataValue)
    setTopUpsValidArr(validations)
    setTopUps(exactDataValue)

  }

  const dataRemoveRecord = (e, valueIndex) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }

    let validations = [...topUpsValidArr]
    if (!!validations && !!validations.length && !!Object.keys(validations).length
      && !!validations[valueIndex] && !!Object.keys(validations[valueIndex]).length
    ) {
      validations.splice(valueIndex, 1)
    }
    setTopUpsValidArr(validations)

    // let exactData = calculationsData[type]
    let exactDataValue = [...topUps]
    exactDataValue.splice(valueIndex, 1)
    setTopUps(exactDataValue)
    checkAllDataCompleted(exactDataValue)
  }

  const tabsAddNewRecord = (e) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    setTopUps(prevState => [...prevState, {
      // id: calculationsData.durations?.length,
      title: '',
      quota: '',
      price: '',
      is_active: true
    }])
    setTopUpsCompleted(false)
  }

  return (
    <div className={classes.BasicInfoRow}>
      <InputLabel id="Service.TopUps" className={classes.labelLineHeight}><FormattedMessage
        id='Services.List.Table.TopUps'/>*:</InputLabel>
      <FormControl variant="outlined">
        {topUps?.map((topUp, index) => (
          <React.Fragment key={index}>
            <div className={classes.pricesWrapper + ' topup-row'}>
              <TextField
                label={intl.formatMessage({ id: 'Fields.label.TopUp.title' }, {
                  span: chunks => <span className={classes.required}>{chunks}</span>
                })}
                id={`Service-${index}-topup-title`}
                name={`Service-${index}-topup-title`}
                type={'text'}
                margin="dense"
                variant="outlined"
                value={topUp?.title || ''}
                InputLabelProps={{
                  shrink: true
                }}
                onChange={e => handleTopUpRecordChange(e, index, 'title')}
                onBlur={ServiceForm.handleBlur}
                error={(!!topUpsValidArr[index] && !!topUpsValidArr[index]?.quota)}
                helperText={!!topUpsValidArr[index] && !!topUpsValidArr[index]?.quota && intl.formatMessage({ id: 'validationSchema.required' })}
              />

              <TextField
                label={intl.formatMessage({ id: 'Fields.label.TopUp.quota' }, {
                  span: chunks => <span className={classes.required}>{chunks}</span>
                })}
                id={`Service-${index}-topup-quota`}
                name={`Service-${index}-topup-quota`}
                type={'number'}
                margin="dense"
                variant="outlined"
                value={topUp?.quota || ''}
                onChange={e => handleTopUpRecordChange(e, index, 'quota')}
                onBlur={ServiceForm.handleBlur}
                error={(!!topUpsValidArr[index] && !!topUpsValidArr[index]?.quota) || !!topUpsDuplicated[index]}
                helperText={!!topUpsValidArr[index] && !!topUpsValidArr[index]?.quota && intl.formatMessage({ id: 'validationSchema.required' })}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  inputProps: {
                    min: 1
                  },
                  endAdornment: <InputAdornment position="end">{ServiceForm.values.quota_unit}</InputAdornment>
                }}
              />
              <TextField
                label={intl.formatMessage({ id: 'Fields.label.TopUp.price' }, {
                  span: chunks => <span className={classes.required}>{chunks}</span>
                })}
                id={`Service-${index}-topup-price`}
                name={`Service-${index}-topup-price`}
                type={'number'}
                margin="dense"
                variant="outlined"
                value={topUp?.price || ''}
                onChange={e => handleTopUpRecordChange(e, index, 'price')}
                onBlur={ServiceForm.handleBlur}
                error={(!!topUpsValidArr[index] && !!topUpsValidArr[index]?.price) || !!topUpsDuplicated[index]}
                helperText={!!topUpsValidArr[index] && !!topUpsValidArr[index]?.price && intl.formatMessage({ id: 'validationSchema.required' })}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  inputProps: {
                    min: 1
                  },
                  endAdornment: <InputAdornment position="end"><FormattedMessage id='egp'/></InputAdornment>
                }}
              />

              <FormControl variant='outlined' margin="dense" className={'switch-wrapper'}>
                <InputLabel id={`Service-label-${index}-topup-is_active`}
                            htmlFor={`Service-${index}-topup-is_active`} shrink={true}><FormattedMessage
                  id='Fields.label.TopUp.is_active'/></InputLabel>
                <FormControlLabel
                  label={!!topUp?.is_active ? intl.formatMessage({ id: 'Services.List.Table.TopUp.Option.Active' }) : intl.formatMessage({ id: 'Services.List.Table.TopUp.Option.inActive' })}
                  value={!!topUp?.is_active}
                  control={
                    <Switch color="primary" checked={topUp?.is_active}
                            value={!!topUp?.is_active}
                            onClick={(e) => {
                              handleTopUpRecordChange(e, index, 'is_active')
                            }}/>
                  }
                />
              </FormControl>

              <div className={classes.removeWrapper}>
                <Button variant="contained" color="secondary" className={classes.removeRecord}
                        startIcon={<DeleteForeverIcon/>}
                        onClick={e => dataRemoveRecord(e, index)}>
                  <FormattedMessage id="Service.topUp.remove"/>
                </Button>
              </div>
            </div>
            {!!topUpsDuplicated[index] &&
            <FormHelperText error><FormattedMessage
              id='validationSchema.service.topUps.duplicated'/></FormHelperText>
            }
          </React.Fragment>
        ))}
        <Button className={classes.AddNewRecord} variant="contained" color="primary"
                onClick={e => tabsAddNewRecord(e, 'durations')}
                disabled={!!topUpsValidArr?.filter(valid => !!valid).length || !topUpsCompleted || !!topUpsDuplicated?.filter(dup => !!dup).length}>
          <FormattedMessage id="Service.topUps.addRecord"/>
        </Button>
        <FormHelperText
          error>{ServiceForm.errors.quotaPrices && ServiceForm.touched.quotaPrices !== undefined &&
        <FormattedMessage id='validationSchema.required'/>}</FormHelperText>

      </FormControl>
    </div>

  )
}

export default TopUps
